import axios from 'axios';

export default function fetchControlStatus() {
    return new Promise((resolve, reject) => axios
        .get('/account/system-admin/api/v1/master-controls')
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.message)));
}
